var React = require('react');

function Editor (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M11.25 6c.398 0 .75.352.75.75a.75.75 0 0 1-.75.75H3.5v12h17v-8.75a.75.75 0 0 1 1.5 0V20c0 .621-.522 1-1 1H3c-.48 0-1-.379-1-1V7c0-.481.38-1 1-1zm-2.011 6.526c-1.045 3.003-1.238 3.45-1.238 3.84 0 .441.385.626.627.626.272 0 1.108-.301 3.829-1.249zm.888-.889 3.22 3.22 8.408-8.4a.834.834 0 0 0 0-1.183l-2.039-2.036a.834.834 0 0 0-1.183 0z"}));
}

Editor.defaultProps = {"fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","clipRule":"evenodd","viewBox":"0 0 24 24"};

module.exports = Editor;

Editor.default = Editor;
